import React from "react"
import SideBar from "../common/layout/sidebar.component"
import InvoicesTabs from "../common/layout/tabs/invoices.component"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing"

const ReturnListing = () => {
    SideBar.activateMenu("invoice")

    return (
        <>
            <InvoicesTabs />
            <GenericListing
                objectType={ObjectType.RETURNS}
            />
        </>
    )
}

export default ReturnListing


// WEBPACK FOOTER //
// ./src/invoice/returnlisting.tsx